<template>
<div class="home  shadow px-4 py-4 rounded bg-gray-700">
    <div v-if="!items.length > 0">
        <img src="~@/assets/icons/empty-cart.svg" class="mx-auto" style="width: 50%; height: 50%;" />
        <p class="text-center m-5 bold">
            Currently No Items in Your Cart
        </p>
        <div class="flex justify-center ">
            <lms-button class="btn-color  " textColor="#fff" @click="$router.push({ name: 'learner-courses' })">View Available Courses</lms-button>
        </div>
    </div>
    <div class="flex flex-wrap">
        <div class="w-full md:w-2/3">
            <div>
                <cart-item @payNow="processPayment($event)" :course="item" v-for="item in items" :key="item.id" />
            </div>
        </div>
        <div class="w-full md:w-1/3">
            <div class="my-4 px-6" v-if="items.length > 0">
                <div class="mt-3 mb-4 inline-flex items-center justify-center">
                    <div>
                        <input v-model="coupon" placeholder="Enter Coupon" class="uppercase h-8 px-2 border border-gray-500 focus:outline-none focus:border-gray-500" type="text" />
                    </div>
                    <button :disabled="cartPrice.appliedCoupons.length > 0" @click="applyCoupon" class="px-2 btn  text-sm text-white h-8 focus:outline-none bg-green-600">
                        {{ couponButton.text }}
                    </button>
                </div>
                <p class="text-red-500 text-xs italic break-words mb-3" v-if="errors.coupon_code">
                    {{ errors.coupon_code.coupon_code }}
                </p>

                <div class="text-gray-800 text-md">Total:</div>
                <div class="text-2xl font-bold text-black">
                    <span v-if="cartTotalFormat !== '0'">&#x20A6;</span>{{ cartTotalFormat !== "0" ?  cartTotalFormat : 'FREE' }}
                </div>
                <div v-if="cartPrice.appliedCoupon">
                    <s><span> <span>&#x20A6;</span>{{ cartPrice.total }} </span></s>
                </div>
                <lms-button @click="processPayment" v-if="(items.length > 0) & (cartTotal > 0)">Checkout</lms-button>
                <lms-button @click="verifyPayment" v-else>Checkout</lms-button>
                <br />
                <h6 class="m-4 bold tenant-main-color">Coupons Used</h6>
                <div v-if="cartPrice.appliedCoupons.length > 0" class="m-4 flex flex-col ">
                    <span :key="i" v-for="i in cartPrice.appliedCoupons">
                        <i @click="removeCoupon" class="fa fa-minus-circle tenant-main-color mr-4 mt-3"></i>
                        {{ i + " is  applied" }}</span>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    mapGetters,
    mapActions,
    mapMutations
} from "vuex";
export default {
    name: "cart-page",
    components: {
        LmsButton: () => import("@/components/general/button"),
        lcontainer: () => import("@/components/general/container"),
        cartItem: () => import("@/components/learner/cartItem"),
    },
    data() {
        return {
            coupon: null,
            errors: {
                coupon_code: false,
            },
            ref: null,
            couponButton: {
                text: "Apply",
                disable: false,
            },
        };
    },
    computed: {
        ...mapGetters({
            cart: "getLearnerCart",
            cartPrice: "getCartTotal",
            user: "getUser",
        }),
        items() {
            return Object.values(this.cart);
        },
        cartTotalFormat() {
            return new Intl.NumberFormat().format(this.cartTotal);
        },
        cartTotal() {
            return this.cartPrice.afterPrice !== 0 ?
                this.cartPrice.afterPrice.toFixed(2) :
                this.cartPrice.total.toFixed(2);
        },
    },
    methods: {
        async applyCoupon() {
            let res = await this.couponToCart({
                coupon_code: this.coupon,
            });

            if (res.status === 400) {
                this.errors.coupon_code = res.data.errors[0].source;
            } else {
                this.errors.coupon_code = false;
                this.coupon = "";
            }
        },
        ...mapActions([
            "learnerRemoveFromCart",
            "fetchCart",
            "couponToCart",
            "learnerCheckout",
        ]),
        ...mapMutations(["addSubscribedCourse", "updateLoader"]),
        nairaToKobo(amount) {
            return (amount * 100).toFixed(0);
        },
        removeSubscribe(course) {
            this.items.map((item) => {
                this.learnerRemoveFromCart({
                    id: item.id,
                });
            });
        },
        async verifyPayment(trx_ref) {
            let res = await this.learnerCheckout({
                amount: parseFloat(this.cartTotal),
                txn_ref: this.ref !== null ?
                    this.ref : Math.random()
                    .toString(36)
                    .substring(7),
            });

            if (res.status === 201 || res.status === 200) {
                this.removeSubscribe();
                this.$Bus.$emit("notify", {
                    type: "success",
                    message: "Transaction Successful",
                });
                this.cartPrice.appliedCoupon = false;
                this.cartPrice.appliedCoupons = [];
                this.cartPrice.total = 0;
                this.cartPrice.afterPrice = 0;
                await this.$router.push({
                    name: "learner-enrolled-courses"
                });
            } else {}
        },
        removeCoupon() {
            this.cartPrice.appliedCoupon = false;
            this.cartPrice.appliedCoupons = [];
            this.cartPrice.afterPrice = 0;
        },
        processPayment() {
            let that = this;
            var handler = PaystackPop.setup({
                key: "pk_live_921e367ae8e08ed0badd3b7081af68c7c0c49fdb",
                email: this.user.email,
                amount: this.nairaToKobo(parseFloat(this.cartTotal)),
                channels: ["card", "bank", "ussd"],
                metadata: {
                    custom_fields: [{
                        user_name: "User",
                        variable_name: this.user.phone_number,
                    }, ],
                },
                callback: function (response) {
                    that.ref = response.reference;
                    that.verifyPayment();
                },
                onClose: function () {
                    //console.log("window closed");
                },
            });

            handler.openIframe();
        },
    },
    async mounted() {
        this.updateLoader(true)
        const payPopup = document.createElement("script");
        payPopup.setAttribute("src", "https://js.paystack.co/v2/inline.js");
        payPopup.async = true;
        document.head.appendChild(payPopup);

        await this.fetchCart();
        this.updateLoader(false)

    },
};
</script>
